<template>
    <div id="app" v-if="$route.name">
        <router-view v-if="isSingePage"></router-view>
        <project-frame v-else />
        <!-- data loading -->
        <DataLoading v-show="DataLoading"></DataLoading>
    </div>
</template>

<script>
    import projectFrame from './components/frame'
    import DataLoading from './components/loading/DataLoading'
    import {mapGetters} from 'vuex'

    export default {
        name: 'App',
        components: {
            projectFrame, DataLoading
        },
        data () {
            return {
                footerwordfixedshow: false,
            }
        },
        computed: mapGetters(['DataLoading']),
        mounted () {
//            this.setSystemClock();
            // 增加百度统计代码
            this.addStatistics();
        },
        methods: {
            async addStatistics() {
                if (this.isNotProEnv() || process.env.NODE_ENV != 'production') return;
                window._hmt = null;
                await this.loadScript("https://hm.baidu.com/hm.js?ea1fe8fd8e78cef22b58bfb72f85cd89", () => {
                    let href = location.href.replace(/^http(s)?:\/\/(.*?)\//, '');
                    this.$store.getters.statistics(href);
                })
            },
            setSystemClock() {
                const that = this
                //用户活动状态循环函数，用户无动作15秒后循环停止
                $('body').on('touchend', 'div', function () {
                    resetsystemClock()
                })
                window.addEventListener("popstate", function (e) {
                    resetsystemClock()
                });
                function resetsystemClock () {
                    if (!window.systemClock) {
                        window.systemClock_num = 0;
                        window.systemClock = setInterval(systemClockFuntion, 500);
                    } else {
                        window.systemClock_num = 0;
                    }
                }
                function systemClockFuntion () {
                    window.systemClock_num++;
                    if (window.systemClock_num > 30) {
                        clearInterval(window.systemClock);
                        window.systemClock = 0;
                        console.log('15秒无动作')
                    }
                    //业务逻辑
                    that.setJszcText()
                }
                resetsystemClock()
            },
            //技术支持文字位置调整（改成循环监测dom高度）
            setJszcText () {
//        console.log(window.activeindex)
//                if(window.activeindex){
//                    this.activeindex=window.activeindex;
//                    console.log('setactiveindex'+window.activeindex)
//                }
//                if (!window.fcgjdocheight) window.fcgjdocheight = 1;
//                // 文档正文高度
//                let documentHeight = $(document).height();
//                if (this.iosBug) {
//                    documentHeight = document.getElementById('app').scrollHeight;
//                }
//                if (documentHeight != window.fcgjdocheight) {
//                    var footerword = $('#footerword').hide();
//                    var mainheight = $('#app').children('div').height() + 40
//                    if (mainheight >= $(window).height()) {//文档高度界面高度或者房产列表页时浮动
//                        footerword.removeClass('footerwordfixed')
//                    } else {
//                        footerword.addClass('footerwordfixed')
//                    }
//                    footerword.show();
//                    if ((location.href + '@').indexOf('/house@') >= 0 && $('.m-list li').length > 0) footerword.addClass('footerwordfixed')
//                    window.fcgjdocheight = documentHeight;
//                }
            }
        }
    };
</script>

<style>
    #app {
        width: 100%;
        height: 100%;
    }
    /* reset vant toast z-index */
    .vantCustomToast {
        z-index: 9999999 !important;
    }
    .cursorp{
        cursor: pointer;
    }
    .ios10bug {
        overflow: scroll;
        position: absolute;
    }

    .footerword {
        display: block;
        text-align: center;
        line-height: 1rem;
        width: 100%;
        color: #999;
    }

    .footerwordfixed {
        position: fixed;
        bottom: 0;
        z-index: 200;
    }

    .prevback {
        /*width: 100%;*/
        height: 0.8rem;
        position: fixed;
        z-index: 9999;
        background-color: rgb(0, 0, 0, 0.3);
        border-radius: 50%;
        top: 50%;
        left: 0.1rem;
        margin-top: -0.4rem;
    }

    .prevback div {
        background: url(./assets/images/prevback_white.png) no-repeat center;
        width: 0.8rem;
        height: 0.8rem;
        background-size: 100%;
    }
    div.aBclick:active,li.aBclick:active,a.aBclick:active,span.aBclick:active,button.aBclick:active,
    .aBclickChild>div:active,.aBclickChild>li:active,.aBclickChild>a:active,.aBclickChild>span:active,.aBclickChild>button:active{
        background-color:#eaeaea!important;color:#585858;border-radius: 8px!important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue